module.exports = __webpack_public_path__ + "img/downtime.2ffe4cea.png";